import {useEffect, useRef, useCallback} from "react"
import Peaks from "peaks.js"

export default function PeaksWaveform({player, waveformUrl, setPlaying, setRender}) {
    const zoomviewRef = useRef(null)
    const peaksRef = useRef(null)

    const resizePeaks = useCallback(() => {
        const peaks = peaksRef.current
        if (!peaks) return
        const zoomview = peaks.views.getView("zoomview")
        zoomview?.fitToContainer()
    }, [])

    useEffect(() => {
        if (!player || !waveformUrl || !zoomviewRef.current) return

        let destroyed = false

        const init = async () => {
            try {
                const res = await fetch(waveformUrl)
                const arraybuffer = await res.arrayBuffer()

                Peaks.init(
                    {
                        mediaElement: player,
                        zoomview: {
                            container: zoomviewRef.current,
                        },
                        waveformData: { arraybuffer },
                        zoomLevels: [256, 512, 1024, 2048, 4096],
                        height: 80,
                    }, (err, peaks) => {
                        if (err || destroyed) return console.error(err)

                        peaksRef.current = peaks
                        const view = peaks.views.getView("zoomview")

                        const updateRender = () => {
                            const beginTime = view.getStartTime()
                            const endTime = view.getEndTime()
                            setRender({
                                beginTime,
                                duration: endTime - beginTime,
                                padding: 2,
                            })
                        }

                        peaks.on("zoomview.displaying", updateRender)
                        peaks.on("zoomview.zoom", updateRender)
                        peaks.on("player.timeupdate", updateRender)
                        peaks.on("player.playing", () => setPlaying?.(true))
                        peaks.on("player.pause", () => setPlaying?.(false))
                        updateRender()
                    }
                )
            } catch (e) {
                console.error("Peaks init error:", e)
            }
        }

        init()

        return () => {
            destroyed = true
                peaksRef.current?.destroy()
            }
    }, [player, waveformUrl])

    useEffect(() => {
        if (!zoomviewRef.current) return

        const observer = new ResizeObserver(() => {
            resizePeaks()
        })

        observer.observe(zoomviewRef.current)
        return () => observer.disconnect()
    }, [resizePeaks])

    return (
        <>
        <div className="waveform">
            <div ref={zoomviewRef} style={{height: 80, width: "100%"}}/>
        </div>
        </>
    )
}